<div class="flex flex-row flex-wrap">
  <div class="flex w-12 md:w-6 pt-2 pr-2">
    <div class="border-round-xl border-1 border-300 w-full p-3">
      <span class="text-gray-800 text-lg font-semibold">
        {{'PaymentDescriptions.CostTitle' | translate}}
      </span>
      <p-divider styleClass="mt-2"/>

      <div class="grid">
        <ng-container *ngIf="delivery?.oceanFreight">
          <span class="col-6">{{'PaymentDescriptions.OceanFreightText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.oceanFreight ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>
        
        <ng-container *ngIf="delivery?.inland">
          <span class="col-6">{{'PaymentDescriptions.PickupText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.inland ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.localCharges">
          <span class="col-6">{{'PaymentDescriptions.LocalChargesText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.localCharges ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>
        
        <ng-container *ngIf="delivery?.customs">
          <span class="col-6">{{'PaymentDescriptions.CustomsText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.customs ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.surcharge">
          <span class="col-6">{{'PaymentDescriptions.SurchargeText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.surcharge ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.handling">
          <span class="col-6">{{'PaymentDescriptions.HandlingText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.handling ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.gateOut">
          <span class="col-6">{{'PaymentDescriptions.GateOutText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.gateOut ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <p-divider *ngIf="hasStaticCosts" styleClass="my-0" class="col-12"/>

        <ng-container *ngIf="delivery?.otherCosts">
          <span class="col-6">{{'PaymentDescriptions.OtherCostText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.otherCosts ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.atmControl">
          <span class="col-6">{{'PaymentDescriptions.AtmControlText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.atmControl ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.co2Reduction">
          <span class="col-6">{{'PaymentDescriptions.Co2ReductionText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.co2Reduction ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.lowSulfurSurcharge">
          <span class="col-6">{{'PaymentDescriptions.LowSulfurSurchargeText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.lowSulfurSurcharge ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.advancedManifestDeclaration">
          <span class="col-6">{{'PaymentDescriptions.AdvancedManifestDeclarationText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.advancedManifestDeclaration ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngIf="delivery?.bunkerAdjustmentFactor">
          <span class="col-6">{{'PaymentDescriptions.BunkerAdjustmentFactorText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{(delivery?.bunkerAdjustmentFactor ?? 0) | currency:'USD':'US$'}}</span>
        </ng-container>

        <ng-container *ngFor="let cost of costsList.originCosts">
          <ng-container *ngIf="cost.amount">
            <span class="col-6">{{cost.description}}</span>
            <span class="col-6 flex justify-content-end">
              {{ cost.amount | currency: cost.currencyCode: cost.currencyCode === 'USD' ? 'US$ ' : 'EU€ ' }}
            </span>
          </ng-container>
        </ng-container>
        
        <ng-container *ngIf="qcReviewCost">
          <span class="col-6">{{'PaymentDescriptions.ReviewQCText' | translate}}</span>
          <span class="col-6 flex justify-content-end">{{qcReviewCost | currency:'USD':'US$'}}</span>
        </ng-container>
        
      <p-divider *ngIf="hasOtherCosts" styleClass="my-0" class="col-12"/>

        <span class="col-6 font-semibold">{{'PaymentDescriptions.TotalOriginCostText' | translate}}</span>
        <span class="col-6 flex justify-content-end font-semibold">{{totalCost | currency:'USD':'US$'}}</span>
        
        <p-divider styleClass="my-0" class="col-12"/>

        <span class="col-12 font-semibold">{{'PaymentDescriptions.OtherDestinationCostText' | translate}}</span>
        <ng-container *ngFor="let cost of costsList.destinationCosts">
          <ng-container *ngIf="cost.amount">
            <span class="col-6">{{cost.description}}</span>
            <span class="col-6 flex justify-content-end">
              {{ cost.amount | currency: cost.currencyCode: cost.currencyCode === 'USD' ? 'US$ ' : 'EU€ ' }}
            </span>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="flex flex-column w-12 md:w-6">
    <div class="w-12 pl-2 py-2">
      <div class="border-round-xl border-1 border-300 w-full p-3">
        <span class="text-gray-800 text-lg font-semibold">
          {{'PaymentDescriptions.DiscountsTitle' | translate}}
        </span>
        <p-divider styleClass="mt-2"/>

        <div class="grid">
          <ng-container *ngFor="let discount of discountsList.originDiscounts">
            <ng-container *ngIf="discount.amount">
              <span class="col-6">{{discount.description}}</span>
              <span class="col-6 flex justify-content-end">{{discount.amount | currency:'USD':'US$'}}</span>
            </ng-container>
          </ng-container>

          <p-divider *ngIf="discounts?.length" styleClass="my-0" class="col-12"/>

          <span class="col-6 font-semibold">{{'PaymentDescriptions.TotalOriginDiscountsText' | translate}}</span>
          <span class="col-6 flex justify-content-end font-semibold">{{totalDiscounts | currency:'USD':'US$'}}</span>

          <p-divider styleClass="my-0" class="col-12"/>
  
          <span class="col-12 font-semibold">{{'PaymentDescriptions.OtherDestinationDiscountText' | translate}}</span>
          <ng-container *ngFor="let discount of discountsList.destinationDiscounts">
            <ng-container *ngIf="discount.amount">
              <span class="col-6">{{discount.description}}</span>
              <span class="col-6 flex justify-content-end">
                {{ discount.amount | currency: discount.currencyCode: discount.currencyCode === 'USD' ? 'US$ ' : 'EU€ ' }}
              </span>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="w-12 pl-2">
      <div class="border-round-xl border-1 border-300 w-full p-3">
        <span class="text-gray-800 text-lg font-semibold">
          {{'PaymentDescriptions.PaymentsTitle' | translate}}
        </span>
        <p-divider styleClass="mt-2"/>

        <div class="grid">
          <ng-container *ngFor="let payment of payments">
            <div class="col-8 flex flex-row align-items-center">
              <p-button 
                *ngIf="payment.id" 
                (onClick)="getPaymentDocument(payment.id)" 
                pTooltip="{{'PaymentDescriptions.ViewPdfText' | translate}}" 
                tooltipPosition="bottom"
                icon="pi pi-file-pdf" 
                styleClass="p-button-link p-0"
                class="download-icon mr-1"/>
              <span *ngIf="payment.description">{{payment.description}}</span>
              <span *ngIf="!payment.description">
                {{'PaymentDescriptions.PaymentText' | translate}} {{payment.created  | date: 'dd/MM/yyyy'}}
              </span>
            </div>
            <span class="col-4 flex justify-content-end">{{payment.amount | currency:'USD':'US$'}}</span>
          </ng-container>

          <p-divider *ngIf="payments?.length" styleClass="my-0" class="col-12"/>

          <span class="col-6 font-semibold">{{'PaymentDescriptions.TotalPaymentText' | translate}}</span>
          <span class="col-6 flex justify-content-end font-semibold">{{totalPayments | currency:'USD':'US$'}}</span>
        </div>
      </div>
    </div>
    <div class="w-12 pl-2 pt-2">
      <div class="border-round-xl border-1 border-300 w-full p-3">
        <span class="text-gray-800 text-lg font-semibold">
          {{'PaymentDescriptions.SummaryTitle' | translate}}
        </span>
        <p-divider styleClass="mt-2"/>

        <div class="grid">
          <span class="col-6 flex align-items-center">
            <span class="material-symbols-outlined summary-icon">paid</span>
            {{'PaymentDescriptions.TotalCostsText' | translate}}
          </span>
          <span class="col-6 flex justify-content-end">{{ totalCost | currency:'USD':'US$'}}</span>

          <span class="col-6 flex align-items-center">
            <span class="material-symbols-outlined summary-icon">downloading</span>
            {{'PaymentDescriptions.TotalDiscountsText' | translate}}
          </span>
          <span class="col-6 flex justify-content-end">{{totalDiscounts | currency:'USD':'US$'}}</span>

          <span class="col-6 flex align-items-center">
            <span class="material-symbols-outlined summary-icon">bar_chart</span>
            {{'PaymentDescriptions.TotalPaymentText' | translate}}
          </span>
          <span class="col-6 flex justify-content-end">{{ totalPayments | currency:'USD':'US$'}}</span>

          <div class="grid col-12 border-round-xl balance-container">
            <span class="col-6 font-semibold">{{'PaymentDescriptions.BalanceText' | translate}}</span>
            <span class="col-6 flex justify-content-end font-semibold">{{ absoluteBalance | currency:'USD':'US$'}}</span>
          </div>

          <p-divider styleClass="my-0" class="col-12"/>

          <span class="col-12 font-semibold">{{'PaymentDescriptions.TotalDestinationCostText' | translate}}</span>
          <ng-container *ngFor="let cost of totalDestinationCosts">
            <ng-container *ngIf="cost.totalAmount">
              <span class="col-6">{{'PaymentDescriptions.TotalCostCurrencyText' | translate}} {{cost.currencyCode}}</span>
              <span class="col-6 flex justify-content-end">
                {{ cost.totalAmount | currency: cost.currencyCode: cost.currencyCode === 'USD' ? 'US$ ' : 'EU€ ' }}
              </span>
            </ng-container>
          </ng-container>

          <p-divider styleClass="my-0" class="col-12"/>

          <span class="col-12 font-semibold">{{'PaymentDescriptions.TotalDestinationDiscountText' | translate}}</span>
          <ng-container *ngFor="let discount of totalDestinationDiscounts">
            <ng-container *ngIf="discount.totalAmount">
              <span class="col-6">{{'PaymentDescriptions.TotalDiscountsCurrencyText' | translate}} {{discount.currencyCode}}</span>
              <span class="col-6 flex justify-content-end">
                {{ discount.totalAmount | currency: discount.currencyCode: discount.currencyCode === 'USD' ? 'US$ ' : 'EU€ ' }}
              </span>
            </ng-container>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>